export default __webpack_public_path__ + "static/12-a46af6b305a2ed991d4b188dafa1071c.jpg";